function onClickCircle(id){
	var clicked = document.getElementById(id);
	if(clicked) {
		var active_values = document.getElementsByClassName("about_value_active");
		var num_active_values = active_values.length;
		if(num_active_values > 0) {
			var old_clicked = active_values[0];

			if(clicked === old_clicked) {
				console.log("clicked === old_clicked");

				return;
			}

			var clicked_int = id.slice(-1);

			if(clicked_int == "1") {
				var value2 = document.getElementById("about_value2");
				var value3 = document.getElementById("about_value3");

				$(value2).css("order", 3);
				$(value3).css("order", 1);
			}
			else if (clicked_int == "2") {
				var value1 = document.getElementById("about_value1");
				var value3 = document.getElementById("about_value3");

				$(value3).css("order", 3);
				$(value1).css("order", 1);		
			}
			else if (clicked_int == "3") {
				var value1 = document.getElementById("about_value1");
				var value2 = document.getElementById("about_value2");

				$(value1).css("order", 3);
				$(value2).css("order", 1);		
			}

			$(".about_value").removeClass("about_value_active");
			$(".about_circle").removeClass("about_circle_active");
			$(clicked).addClass("about_value_active");
			$(clicked).css("order", 2);
			$("#about_circle" + clicked_int).addClass("about_circle_active");

		}
	}
}